export default "__VITE_PUBLIC_ASSET__8197f120__"